import Vue from "vue";
import { apiConstants } from "../../config";
import {
  apiPost,
  apiPut,
  apiGet
} from "../../../../shared/services";
const fetchUsers = async options => {
  const url = apiConstants.users;
  return await apiGet(url, { params: options });
};

const fetchRoles = async options => {
  const url = apiConstants.roles;
  return await apiGet(url, { params: options });
};

const saveUser = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.users + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.users;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchUser = async id => {
  const url = apiConstants.users;
  return await apiGet(url + "/" + id);
};

const deleteUser = async id => {
  const url = apiConstants.users;
  return await Vue.axios.delete(url + "/" + id);
};

export { fetchUsers, fetchRoles, saveUser, deleteUser, fetchUser };
